import React, { useContext } from 'react';
import { ISubcategoryContext, SubcategoryContext } from '../../../subcategoryState/subcategoryContext';
import SearchField from 'components/SearchField/SearchField';

export const Search: React.FC = () => {
	const { changeSearchString, searchString, subcategoriesByCustomer, subcategoriesByRestaurant } =
		useContext<ISubcategoryContext>(SubcategoryContext);

	return (
		<SearchField
			onChangeSelectSearchString={changeSearchString}
			searchString={searchString}
			delay={subcategoriesByCustomer.totalCount || subcategoriesByRestaurant.totalCount ? 800 : undefined}
		/>
	);
};
